{
    "(save {highestYearlyDiscount}%)": "({highestYearlyDiscount}% সঞ্চয়)",
    "{amount} days free": "{amount} দিন ফ্রি",
    "{amount} off": "{amount} ছাড়",
    "{amount} off for first {number} months.": "প্রথম {number} মাসের জন্য {amount} ছাড়।",
    "{amount} off for first {period}.": "প্রথম {period} এর জন্য {amount} ছাড়।",
    "{amount} off forever.": "চিরতরে {amount} ছাড়।",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% ছাড়",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} আর {newsletterName} নিউজলেটার পাবেন না।",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} আপনার মন্তব্যের উত্তর দিলে আর ইমেল পাবেন না।",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} আর এই নিউজলেটার পাবেন না।",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} দিন ফ্রি",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "অ্যাকাউন্ট",
    "Account details updated successfully": "",
    "Account settings": "অ্যাকাউন্ট সেটিংস",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "একটি ফ্রি ট্রায়াল শেষ হওয়ার পরে, আপনি যেই টিয়ারটি বেছে নিয়েছেন তার নিয়মিত মূল্য চার্জ করা হবে। আপনি যে কোনো সময় বাতিল করতে পারেন।",
    "Already a member?": "ইতিমধ্যেই সদস্য?",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "",
    "Back": "ফিরে যান",
    "Back to Log in": "লগইনে ফিরে যান",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "ঈদ-উল-ফিতর",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "যে কোনো সময় বাতিল করুন।",
    "Cancel subscription": "সাবস্ক্রিপশন বাতিল করুন",
    "Canceled": "",
    "Cancellation reason": "বাতিলের কারণ",
    "Change": "পরিবর্তন",
    "Change plan": "",
    "Check spam & promotions folders": "স্প্যাম ও প্রমোশন ফোল্ডার চেক করুন",
    "Check with your mail provider": "আপনার মেইল প্রোভাইডারের সাথে চেক করুন",
    "Check your inbox to verify email update": "",
    "Choose": "বেছে নিন",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "একটি ভিন্ন পরিকল্পনা বেছে নিন",
    "Choose a plan": "",
    "Choose a tier": "",
    "Choose your newsletters": "আপনার নিউজলেটার বেছে নিন",
    "Click here to retry": "আবার চেষ্টা করতে এখানে ক্লিক করুন",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "বন্ধ করুন",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "মন্তব্য",
    "Complimentary": "সম্পূর্ণ বিনামূল্যে",
    "Confirm": "নিশ্চিত করুন",
    "Confirm cancellation": "বাতিল নিশ্চিত করুন",
    "Confirm subscription": "সাবস্ক্রিপশন নিশ্চিত করুন",
    "Contact support": "সাপোর্টের সাথে যোগাযোগ করুন",
    "Continue": "চালিয়ে যান",
    "Continue subscription": "সাবস্ক্রিপশন চালিয়ে যান",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "সাইন ইন করতে পারেনি। লগইন লিঙ্কের মেয়াদ শেষ হয়েছে।",
    "Could not update email! Invalid link.": "ইমেল আপডেট করতে পারেনি! অবৈধ লিঙ্ক।",
    "Create a new contact": "একটি নতুন যোগাযোগ তৈরি করুন",
    "Current plan": "বর্তমান পরিকল্পনা",
    "Delete account": "অ্যাকাউন্ট মুছে ফেলুন",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "এটি করার উদ্দেশ্য ছিল না? আপনার পছন্দগুলি পরিচালনা করুন <button>এখানে</button>।",
    "Don't have an account?": "অ্যাকাউন্ট নেই?",
    "Edit": "সম্পাদনা করুন",
    "Email": "ইমেল",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "ইমেল নিউজলেটার",
    "Email newsletter settings updated": "",
    "Email preferences": "ইমেল পছন্দ",
    "Email preferences updated.": "",
    "Emails": "ইমেল",
    "Emails disabled": "ইমেল নিষ্ক্রিয়",
    "Ends {offerEndDate}": "{offerEndDate} এ শেষ হবে",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "",
    "Enter your name": "",
    "Error": "ত্রুটি",
    "Expires {expiryDate}": "{expiryDate} এ মেয়াদ শেষ",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "চিরকাল",
    "Free Trial – Ends {trialEnd}": "ফ্রি ট্রায়াল – {trialEnd} এ শেষ হবে",
    "From": "",
    "Get help": "সাহায্য পান",
    "Get in touch for help": "সহায়তার জন্য যোগাযোগ করুন",
    "Get notified when someone replies to your comment": "কেউ আপনার মন্তব্যের উত্তর দিলে জানানো হবে",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "এই পোস্টে প্রতিক্রিয়া দিন",
    "Help! I'm not receiving emails": "সাহায্য! আমি ইমেল পাচ্ছি না",
    "Here are a few other sites you may enjoy.": "এখানে কয়েকটি অন্যান্য সাইট রয়েছে যা আপনি উপভোগ করতে পারেন।",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "যদি একটি নিউজলেটার স্প্যাম হিসেবে চিহ্নিত হয়, তবে ইমেলগুলি স্বয়ংক্রিয়ভাবে সেই ঠিকানার জন্য নিষ্ক্রিয় করা হয় যাতে আপনি আর কোনো অবাঞ্ছিত বার্তা না পান।",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "যদি স্প্যাম অভিযোগটি দুর্ঘটনাক্রমে হয়ে থাকে, অথবা আপনি আবার ইমেলগুলি পেতে শুরু করতে চান, তবে পূর্ববর্তী স্ক্রিনে বোতামটি ক্লিক করে আপনি ইমেলগুলিতে পুনঃসাবস্ক্রাইব করতে পারেন।",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "আপনি যদি এখন আপনার সাবস্ক্রিপশন বাতিল করেন, তবে {periodEnd} পর্যন্ত আপনার প্রবেশাধিকার থাকবে।",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "যদি আপনার কর্পোরেট বা সরকারি ইমেল অ্যাকাউন্ট থাকে, তবে আপনার আইটি বিভাগের সাথে যোগাযোগ করুন এবং তাদেরকে বলুন {senderEmail} থেকে ইমেলগুলি গ্রহণের অনুমতি দিতে।",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "একটি লগইন লিঙ্ক আপনার ইনবক্সে পাঠানো হয়েছে। যদি এটি ৩ মিনিটের মধ্যে না পৌঁছায়, তবে আপনার স্প্যাম ফোল্ডার চেক করুন।",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "আপনি যদি আবার ইমেল পেতে শুরু করতে চান, তবে সেরা পরবর্তী পদক্ষেপগুলি হল যে কোনো সমস্যার জন্য আপনার ফাইলে থাকা ইমেল ঠিকানাটি পরীক্ষা করা এবং তারপর পূর্ববর্তী স্ক্রিনে পুনঃসাবস্ক্রাইব ক্লিক করা।",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "আপনি যদি সাবস্ক্রাইব করা ইমেল নিউজলেটারটি না পেয়ে থাকেন, তবে এখানে কয়েকটি বিষয় পরীক্ষা করতে পারেন।",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "আপনি যদি এই সমস্ত পরীক্ষা সম্পূর্ণ করেন এবং এখনও ইমেল না পান, তবে {supportAddress} এর সাথে যোগাযোগ করে সাপোর্ট পেতে পারেন।",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "একটি নিউজলেটার পাঠানোর চেষ্টা করার সময় স্থায়ী ব্যর্থতা পাওয়া গেলে, অ্যাকাউন্টে ইমেলগুলি নিষ্ক্রিয় করা হবে।",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "আপনার ইমেল ক্লায়েন্টে {senderEmail} কে আপনার যোগাযোগ তালিকায় যোগ করুন। এটি আপনার মেইল প্রোভাইডারকে সংকেত দেয় যে এই ঠিকানা থেকে পাঠানো ইমেলগুলি বিশ্বাসযোগ্য হওয়া উচিত।",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "এটির মতো কম",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "নিশ্চিত করুন যে ইমেলগুলি দুর্ঘটনাক্রমে আপনার ইনবক্সের স্প্যাম বা প্রমোশন ফোল্ডারে শেষ হচ্ছে না। যদি তারা হয়, তাহলে \"স্প্যাম নয়\" চিহ্নিত করুন এবং/অথবা \"ইনবক্সে সরান\" ক্লিক করুন।",
    "Manage": "পরিচালনা করুন",
    "Maybe later": "সম্ভবত পরে",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "সদস্যতা অপ্রাপ্য, প্রবেশাধিকার পেতে মালিকের সাথে যোগাযোগ করুন।",
    "month": "",
    "Monthly": "মাসিক",
    "More like this": "এটির মতো আরো",
    "More options": "",
    "Name": "নাম",
    "Need more help? Contact support": "আরও সাহায্য প্রয়োজন? সাপোর্টের সাথে যোগাযোগ করুন",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "আপনার অ্যাকাউন্টে দুটি কারণে নিউজলেটার নিষ্ক্রিয় করা যেতে পারে: একটি পূর্ববর্তী ইমেল স্প্যাম হিসাবে চিহ্নিত করা হয়েছিল, অথবা একটি ইমেল পাঠানোর চেষ্টা স্থায়ী ব্যর্থতার (বাউন্স) ফলাফল।",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "ইমেল পাচ্ছেন না?",
    "Now": "",
    "Now check your email!": "এখন আপনার ইমেল চেক করুন!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "একবার পুনঃসাবস্ক্রাইব করার পর, যদি আপনি এখনও আপনার ইনবক্সে ইমেল না দেখেন, তবে আপনার স্প্যাম ফোল্ডার চেক করুন। কিছু ইনবক্স প্রোভাইডার পূর্ববর্তী স্প্যাম অভিযোগগুলির একটি রেকর্ড রাখে এবং ইমেলগুলি চিহ্নিত করতে থাকে। যদি এটি ঘটে, তাহলে সর্বশেষ নিউজলেটারটিকে 'স্প্যাম নয়' হিসাবে চিহ্নিত করুন যাতে এটি আপনার প্রাথমিক ইনবক্সে ফিরে যায়।",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "স্থায়ী ব্যর্থতা (বাউন্স)",
    "Phone number": "",
    "Plan": "পরিকল্পনা",
    "Plan checkout was cancelled.": "পরিকল্পনার চেকআউট বাতিল করা হয়েছে।",
    "Plan upgrade was cancelled.": "পরিকল্পনার আপগ্রেড বাতিল করা হয়েছে।",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "আপনার বিনামূল্যের সাবস্ক্রিপশন সমন্বয় করতে অনুগ্রহ করে {supportAddress} এর সাথে যোগাযোগ করুন।",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "প্রয়োজনীয় ক্ষেত্রগুলি পূরণ করুন",
    "Podcasts": "",
    "Re-enable emails": "ইমেলগুলি পুনরায় সক্রিয় করুন",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "প্রস্তাবনা",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "{price} এ নবায়ন হবে।",
    "Resume subscription": "",
    "Retry": "আবার চেষ্টা করুন",
    "Save": "সংরক্ষণ করুন",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "লগইন লিঙ্ক পাঠানো হচ্ছে...",
    "Sending...": "পাঠানো হচ্ছে...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "সব দেখান",
    "Sign in": "সাইন ইন করুন",
    "Sign out": "সাইন আউট করুন",
    "Sign up": "সাইন আপ করুন",
    "Signup error: Invalid link": "সাইন আপ ত্রুটি: অবৈধ লিঙ্ক",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "দুঃখিত, এটি কাজ করেনি।",
    "Spam complaints": "স্প্যাম অভিযোগ",
    "Start {amount}-day free trial": "{amount}-দিনের ফ্রি ট্রায়াল শুরু করুন",
    "Starting {startDate}": "{startDate} থেকে শুরু",
    "Starting today": "আজ থেকে শুরু",
    "Submit feedback": "প্রতিক্রিয়া জমা দিন",
    "Subscribe": "সাবস্ক্রাইব করুন",
    "Subscribed": "সাবস্ক্রাইব করা হয়েছে",
    "Subscription plan updated successfully": "",
    "Success": "সফলতা",
    "Success! Check your email for magic link to sign-in.": "সফলতা! সাইন ইন করার জন্য ম্যাজিক লিঙ্কের জন্য আপনার ইমেল চেক করুন।",
    "Success! Your account is fully activated, you now have access to all content.": "সফলতা! আপনার অ্যাকাউন্ট সম্পূর্ণরূপে সক্রিয় হয়েছে, এখন আপনি সমস্ত কন্টেন্টে প্রবেশ করতে পারবেন।",
    "Success! Your email is updated.": "সফলতা! আপনার ইমেল আপডেট হয়েছে।",
    "Successfully unsubscribed": "সফলভাবে আনসাবস্ক্রাইব করা হয়েছে",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "সাবস্ক্রাইব করার জন্য ধন্যবাদ। পড়া শুরু করার আগে, নিচে কয়েকটি অন্যান্য সাইট রয়েছে যা আপনি উপভোগ করতে পারেন।",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "প্রতিক্রিয়ার জন্য ধন্যবাদ!",
    "That didn't go to plan": "পরিকল্পনা অনুযায়ী হয়নি",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "আমাদের কাছে আপনার জন্য যে ইমেল ঠিকানাটি রয়েছে তা হল {memberEmail} — যদি এটি সঠিক না হয়, তবে আপনি আপনার <button>অ্যাকাউন্ট সেটিংস এলাকায়</button> এটি আপডেট করতে পারেন।",
    "There was a problem submitting your feedback. Please try again a little later.": "আপনার প্রতিক্রিয়া জমা দেওয়ার সময় একটি সমস্যা হয়েছে। অনুগ্রহ করে একটু পরে আবার চেষ্টা করুন।",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "এই সাইটটি কেবল আমন্ত্রণের মাধ্যমে, প্রবেশাধিকার পেতে মালিকের সাথে যোগাযোগ করুন।",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "সাইন আপ সম্পূর্ণ করতে, আপনার ইনবক্সে নিশ্চিতকরণ লিঙ্কে ক্লিক করুন। যদি এটি ৩ মিনিটের মধ্যে না আসে, তবে আপনার স্প্যাম ফোল্ডার চেক করুন!",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "{amount} দিনের জন্য ফ্রি চেষ্টা করুন, তারপর {originalPrice}।",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "পেইড সাবস্ক্রাইবার হয়ে সমস্ত নিউজলেটারে প্রবেশাধিকার আনলক করুন।",
    "Unsubscribe from all emails": "সমস্ত ইমেল থেকে আনসাবস্ক্রাইব করুন",
    "Unsubscribed": "আনসাবস্ক্রাইব করা হয়েছে",
    "Unsubscribed from all emails.": "সমস্ত ইমেল থেকে আনসাবস্ক্রাইব করা হয়েছে।",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "ইমেল থেকে আনসাবস্ক্রাইব করা {title} এর জন্য আপনার পেইড সাবস্ক্রিপশন বাতিল করবে না",
    "Update": "আপডেট করুন",
    "Update your preferences": "আপনার পছন্দগুলি আপডেট করুন",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "যাচাইকরণ লিঙ্ক পাঠানো হয়েছে, আপনার ইনবক্স চেক করুন",
    "Verify your email address is correct": "আপনার ইমেল ঠিকানা সঠিক কিনা যাচাই করুন",
    "Verifying...": "",
    "View plans": "পরিকল্পনা দেখুন",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "আমরা আপনাকে আনসাবস্ক্রাইব করতে পারিনি কারণ ইমেল ঠিকানা পাওয়া যায়নি। অনুগ্রহ করে সাইট মালিকের সাথে যোগাযোগ করুন।",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "আবার স্বাগতম, {name}!",
    "Welcome back!": "আবার স্বাগতম!",
    "Welcome to {siteTitle}": "{siteTitle} এ স্বাগতম",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "যখন একটি ইনবক্স একটি ইমেল গ্রহণ করতে ব্যর্থ হয় তখন এটি সাধারণত বাউন্স হিসাবে পরিচিত। অনেক ক্ষেত্রে, এটি অস্থায়ী হতে পারে। তবে, কিছু ক্ষেত্রে, একটি বাউন্সড ইমেল একটি স্থায়ী ব্যর্থতা হিসাবে ফেরত আসতে পারে যখন একটি ইমেল ঠিকানা অবৈধ বা অস্তিত্বহীন হয়।",
    "Why has my email been disabled?": "আমার ইমেল নিষ্ক্রিয় করা হয়েছে কেন?",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "বার্ষিক",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "আপনার বর্তমানে একটি ফ্রি সদস্যতা রয়েছে, সম্পূর্ণ প্রবেশাধিকারের জন্য একটি পেইড সাবস্ক্রিপশনে আপগ্রেড করুন।",
    "You have been successfully resubscribed": "আপনি সফলভাবে পুনঃসাবস্ক্রাইব হয়েছেন",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "আপনি বর্তমানে ইমেল পাচ্ছেন না",
    "You're not receiving emails": "আপনি ইমেল পাচ্ছেন না",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "আপনি ইমেল পাচ্ছেন না কারণ আপনি হয়তো একটি সাম্প্রতিক বার্তা স্প্যাম হিসেবে চিহ্নিত করেছেন, অথবা বার্তাগুলি আপনার প্রদত্ত ইমেল ঠিকানায় বিতরণ করা যায়নি।",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "আপনি সফলভাবে সাইন ইন করেছেন।",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "আপনি সফলভাবে সাবস্ক্রাইব করেছেন <strong>{siteTitle}</strong>",
    "Your account": "আপনার অ্যাকাউন্ট",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "আপনার ইনপুট প্রকাশিত হওয়ার বিষয়টি নির্ধারণ করতে সহায়তা করে।",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "আপনার সাবস্ক্রিপশনের মেয়াদ {expiryDate} এ শেষ হবে",
    "Your subscription will renew on {renewalDate}": "আপনার সাবস্ক্রিপশন {renewalDate} এ নবায়ন হবে",
    "Your subscription will start on {subscriptionStart}": "আপনার সাবস্ক্রিপশন {subscriptionStart} থেকে শুরু হবে"
}
